export default __webpack_public_path__ + "images/symbols.svg?147027a4906d0c1e2b29876bf69beea5";